// src/utils/worksheetVoice.js
//
// Audience voice for the interactive checklists / worksheets. Sheet text may
// carry inline alternatives written as {sport text|corporate text}; this picks
// the right side for the organization's industry. Precise by design — the
// app-wide regex adapter (adaptText.js) rewrites every "practice" as
// "workday", which mangles "practice mindfulness daily", so sheets don't use it.
//
//   voiceText('Before a {game|big meeting}, run your routine.', true)
//   -> 'Before a big meeting, run your routine.'

const TOKEN = /\{([^{}|]*)\|([^{}]*)\}/g;

export const voiceText = (text, isCorporate) => {
    if (typeof text !== 'string' || text.indexOf('{') === -1) return text;
    return text.replace(TOKEN, (_, sport, corporate) => (isCorporate ? corporate : sport));
};

// Both readings of a string — handy for tests / content review
export const voiceVariants = (text) => ({ sport: voiceText(text, false), corporate: voiceText(text, true) });
